import React from 'react'
import classes from "./spinner.module.css"
const LoadingSpinner = () => {
  return (
    <div className={classes.spinnerOverLay}>
      <div className={classes.loadingSpinner}></div>
    </div>
  )
}

export default LoadingSpinner;